// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';
import { TAccountRootCreateReq, TAccountRootUpdateReq } from '../types/requests';

export function AccountRootController() {
  const getAllAccountRoots = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/account-root/`, {
      headers: getAuthHeaders(),
    });
  };

  const deleteAccountRoot = async <T>(rootId: number): Promise<T> => {
    return await axios.delete(`${DEV_APP_API_URL}/account-root/${rootId}`, {
      headers: getAuthHeaders(),
    });
  };

  const createAccountRoot = async <T>(data: TAccountRootCreateReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/account-root/`, data, {
      headers: getAuthHeaders(),
    });
  };

  const updateAccountRoot = async <T>(data: TAccountRootUpdateReq): Promise<T> => {
    return await axios.put(`${DEV_APP_API_URL}/account-root/${data.rootId}`, data.data, {
      headers: getAuthHeaders(),
    });
  };

  return { getAllAccountRoots, deleteAccountRoot, createAccountRoot, updateAccountRoot };
}
